import React, { useEffect, useMemo, useState } from 'react';
import styles from './drfredericocardioped.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

import ServiceImg1 from './src/1.png';
import ServiceImg2 from './src/2.png';
import ServiceImg3 from './src/3.png';

const Drfredericocardioped: React.FC = () => {
    const doctorName = "Dr. Frederico Ramos";

    const services = useMemo(() => ([
        {
            id: "eco-pediatrico",
            label: "Ecocardiograma pediátrico",
            whatsappServiceText: "um ecocardiograma pediátrico",
            instagramUrl: "https://www.instagram.com/hospitalvillage?igsh=MXB0azAxaTY5Y3Uydw==",
            instagramHandle: "hospitalvillage",
            phoneBR: "551733231010",
            imageSrc: ServiceImg1,
        },
        {
            id: "cardio-pediatrica",
            label: "Cardiologia pediátrica",
            whatsappServiceText: "uma consulta de cardiologia pediátrica",
            instagramUrl: "https://www.instagram.com/institutocrescercomafeto?igsh=MXF0N2NkMnd0aXN4cQ==",
            instagramHandle: "institutocrescercomafeto",
            phoneBR: "5517997420841",
            imageSrc: ServiceImg2,
        },
        {
            id: "eco-fetal",
            label: "Ecocardiograma fetal",
            whatsappServiceText: "um ecocardiograma fetal",
            instagramUrl: "https://www.instagram.com/centromedicodonavitta_?igsh=bnFvdmxmdWpnMW1j",
            instagramHandle: "centromedicodonavitta_",
            phoneBR: "5517981360002",
            imageSrc: ServiceImg3,
        },
    ]), []);

    const [activeServiceId, setActiveServiceId] = useState<string | null>(null);
    const activeService = services.find(s => s.id === activeServiceId) ?? null;

    const whatsappUrl = useMemo(() => {
        if (!activeService) return "";
        const message = `Olá! Gostaria de agendar ${activeService.whatsappServiceText} com o ${doctorName}.`;
        return `https://wa.me/${activeService.phoneBR}?text=${encodeURIComponent(message)}`;
    }, [activeService, doctorName]);

    useEffect(() => {
        if (!activeService) return;
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") setActiveServiceId(null);
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [activeService]);

    return (
        <div className={styles.drfredericocardioped}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles.cardOverlay}>
                        <h1 className="mb-0">Dr. Frederico Ramos</h1>
                        <p>CARDIOPEDIATRIA</p>
                        <div className={styles.links}>

                            {services.map((service) => (
                                <button
                                    key={service.id}
                                    onClick={() => setActiveServiceId(service.id)}
                                    type="button"
                                    className={styles.linkButton}
                                >
                                    <span className={styles.btnIconCol}>
                                        <img
                                            src={service.imageSrc}
                                            alt={service.label}
                                            className={styles.serviceAvatarSm}
                                        />
                                    </span>
                                    <span className={styles.btnText}>{service.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {activeService && (
                <div
                    className={styles.modalOverlay}
                    role="dialog"
                    aria-modal="true"
                    aria-label={activeService.label}
                    onMouseDown={(e) => {
                        if (e.target === e.currentTarget) setActiveServiceId(null);
                    }}
                >
                    <div className={styles.modalCard}>
                        <div className={styles.modalHeader}>
                            <h2 className={styles.modalTitle}>{activeService.label}</h2>
                            <button
                                className={styles.modalClose}
                                type="button"
                                onClick={() => setActiveServiceId(null)}
                                aria-label="Fechar"
                            >
                                ✕
                            </button>
                        </div>

                        <div className={styles.modalContent}>
                            <div className={styles.modalAvatarWrap}>
                                <img
                                    className={styles.modalAvatar}
                                    src={activeService.imageSrc}
                                    alt={activeService.instagramHandle}
                                />
                            </div>

                            <div className={styles.modalIgLine}>
                                <a
                                    className={styles.modalIgHandle}
                                    href={activeService.instagramUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    @{activeService.instagramHandle}
                                </a>
                            </div>

                            <div className={styles.modalActions}>
                                <a
                                    className={styles.modalPrimaryBtn}
                                    href={whatsappUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className={styles.modalBtnIcon}>
                                        <WhatsappIcon height="22" color="#ffffff" />
                                    </span>
                                    <span className={styles.modalBtnText}>Agendar no WhatsApp</span>
                                </a>
                                <a
                                    className={styles.modalSecondaryBtn}
                                    href={activeService.instagramUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <span className={styles.modalBtnIcon}>
                                        <InstagramIcon height="20" color="#ffffff" />
                                    </span>
                                    <span className={styles.modalBtnText}>Abrir Instagram</span>
                                </a>
                            </div>

                            <div className={styles.modalHint}>
                                Se preferir, clique no @ para abrir o perfil.
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Drfredericocardioped;
